import { render } from "./WelcomePanel.vue?vue&type=template&id=bcea4644"
import script from "./WelcomePanel.vue?vue&type=script&lang=js"
export * from "./WelcomePanel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__